module.exports = __webpack_public_path__ + "static/media/Vaishnodevi_Farmville.4a9ab256.pdf";